module.exports = __webpack_public_path__ + "static/media/slots.6a196247.png";